import { useState } from 'react';
import logger from '../../utils/logger';

// Sous-hook Messagerie : emails programmés (liste + annulation).
export function useMailScheduled({ backendUrl, authToken, showSuccess, showError }) {
  const [scheduledEmails, setScheduledEmails] = useState([]);
  const [scheduledEmailsLoading, setScheduledEmailsLoading] = useState(false);

  const loadScheduledEmails = async () => {
    setScheduledEmailsLoading(true);
    try {
      const response = await fetch(`${backendUrl}/api/admin/mail/scheduled`, {
        headers: { 'Authorization': `Bearer ${authToken}` }
      });

      if (response.ok) {
        const data = await response.json();
        setScheduledEmails(data.scheduled_emails || []);
      }
    } catch (error) {
      logger.error('Error loading scheduled emails:', error);
      showError('Erreur lors du chargement des emails programmés');
    } finally {
      setScheduledEmailsLoading(false);
    }
  };

  const cancelScheduledEmail = async (scheduledId) => {
    try {
      const response = await fetch(`${backendUrl}/api/admin/mail/scheduled/${scheduledId}`, {
        method: 'DELETE',
        headers: { 'Authorization': `Bearer ${authToken}` }
      });

      if (response.ok) {
        showSuccess('Email programmé annulé');
        loadScheduledEmails();
      } else {
        throw new Error('Erreur lors de l\'annulation');
      }
    } catch (error) {
      logger.error('Error canceling scheduled email:', error);
      showError('Erreur lors de l\'annulation de l\'email programmé');
    }
  };

  return { scheduledEmails, scheduledEmailsLoading, loadScheduledEmails, cancelScheduledEmail };
}
